import clsx from "clsx";
import ClockIcon from "@ancon/wildcat-ui/shared/icons/clock-circle-outline.svg";
import LaterIcon from "@ancon/wildcat-ui/shared/icons/later-outline.svg";
import { ServiceTimeKindType } from "@ancon/wildcat-types";

import styles from "./NavBarOrderTimeSwitch.module.scss";
import NavBarOrderTimeSwitchButton from "./NavBarOrderTimeSwitchButton";

type NavBarOrderTimeSwitchProps = {
  isInNavBar?: boolean;
};

export default function NavBarOrderTimeSwitch({
  isInNavBar = true,
}: NavBarOrderTimeSwitchProps) {
  return (
    <div className={clsx(styles.container, isInNavBar && styles.navBar)}>
      <NavBarOrderTimeSwitchButton
        type={ServiceTimeKindType.AsSoonAsPossible}
        isInNavBar={isInNavBar}
      >
        <ClockIcon />
        <span>Order Now</span>
      </NavBarOrderTimeSwitchButton>
      <NavBarOrderTimeSwitchButton
        type={ServiceTimeKindType.AtSpecifiedTime}
        isInNavBar={isInNavBar}
      >
        <LaterIcon />
        <span className={styles.capitalize}>Later</span>
      </NavBarOrderTimeSwitchButton>
    </div>
  );
}
